import { render } from "./upload2.vue?vue&type=template&id=175c31b0&scoped=true"
import script from "./upload2.vue?vue&type=script&lang=js"
export * from "./upload2.vue?vue&type=script&lang=js"

import "./upload2.vue?vue&type=style&index=0&id=175c31b0&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175c31b0"]])

export default __exports__